import { gql } from "@apollo/client";

export const GET_CUSTOMER_GROUPS = gql`
  query GET_CUSTOMER_GROUPS(
    $searchTerm: String
    # $searchTermInteger: Int
    # $language: EnumLanguageFilter
    $take: Int
    $skip: Int
    $orderBy: [CustomerGroupOrderByWithRelationInput!]
    $filters: [CustomerGroupWhereInput]
  ) {
    findManyCustomerGroupCount(
      where: {
        OR: [{ name: { mode: insensitive, contains: $searchTerm } }]
        AND: $filters
      }
    )

    findManyCustomerGroup(
      orderBy: $orderBy
      where: {
        OR: [{ name: { mode: insensitive, contains: $searchTerm } }]
        AND: $filters
      }
      take: $take
      skip: $skip
    ) {
      # ----- The customer
      id
      createdAt
      name
      fabric_palettes {
        name
        id
      }
      price_listId
      price_list {
        id
        name
      }
      _count {
        Customer
        fabric_palettes
      }
    }
  }
`;

export const DELETE_CUSTOMERS_GROUPS = gql`
  mutation DELETE_CUSTOMERS_GROUPS($ids: [Int!]!) {
    deleteManyCustomerGroup(where: { id: { in: $ids } }) {
      count
    }
  }
`;

export const DELETE_SINGLE_CUSTOMER_GROUP = gql`
  mutation DELETE_SINGLE_CUSTOMER_GROUP($id: Int!) {
    deleteOneCustomerGroup(where: { id: $id }) {
      id
    }
  }
`;

export const CORE_CUSTOMER_GROUP_DATA = gql`
  fragment CoreCustomerGroupData on CustomerGroup {
    id
    name
    fabric_palettes {
      id
    }
    price_listId
    price_list {
      id
      name
    }
    additional_components {
      id
      additionalComponent {
        additional_component_profiles(where: $where) {
          name
          language
        }
      }
    }
  }
`;

//  TODO ======
export const CREATE_CUSTOMER_GROUP = gql`
  mutation CREATE_CUSTOMER_GROUP(
    $name: String!
    $price_listId: Int
  ) {
    createCustomerGroup(
      name: $name
      price_listId: $price_listId
    ) {
      id
    }
  }
`;

export const CUSTOMER_GROUP_DATA = gql`
  fragment CustomerGroupData on CustomerGroup {
    id
    name
    fabric_palettes {
      id
    }
    price_listId
    additional_components {
      id
      additionalComponent {
        id
        additionalComponentGroupId
        additional_component_profiles(
          where: { language: { equals: $language } }
        ) {
          name
          language
        }
      }
    }
  }
`;

export const UPDATE_CUSTOMER_GROUP = gql`
  ${CUSTOMER_GROUP_DATA}
  mutation UPDATE_CUSTOMER_GROUP(
    $id: Int!
    $language: Language
    $additional_components: [Int]
    $name: String!
    $fabric_palettes: [Int]
    $price_listId: Int
  ) {
    updateCustomerGroup(
      where: { id: $id }
      name: $name
      fabric_palettes: $fabric_palettes
      additional_components: $additional_components
      price_listId: $price_listId
    ) {
      ...CustomerGroupData
    }
  }
`;

export const GET_CUSTOMER_GROUP = gql`
  ${CUSTOMER_GROUP_DATA}
  query GET_CUSTOMER_GROUP($id: Int!, $language: Language) {
    findUniqueCustomerGroup(where: { id: $id }) {
      ...CustomerGroupData
    }
  }
`;

export const GET_PALETTES = gql`
  query GET_PALETTES {
    findManyFabricPalette {
      id
      name
    }
  }
`;
